import { useTranslation } from 'react-i18next';

import * as St from './SlabViewerTooltip.styles';

import { MATERIAL_ATTR_MAP, TOOLTIP_PLACEMENT } from '~/core/constants';
import { Feature } from '~/core/models';
import ImageWithSkeleton from '~atoms/ImageWithSkeleton';

interface SlabViewerTooltipProps {
  feature: Feature;
}

const SlabViewerTooltip = ({
  feature,
}: SlabViewerTooltipProps): JSX.Element => {
  const { t } = useTranslation();

  const getFeatureDescription = (name: string): string => {
    const attribute = MATERIAL_ATTR_MAP[name];

    return attribute
      ? t(`SCROLLABLE_AREA.COLOR.VIEW_SLAB.${attribute.textKey}`)
      : '';
  };

  return (
    <St.Container
      placement={TOOLTIP_PLACEMENT}
      overlayClassName="SlabViewer__tooltip"
      title={
        <>
          <St.TooltipStrongText>{feature.value}</St.TooltipStrongText>
          {getFeatureDescription(feature.value)}
        </>
      }
      arrowPointAtCenter
      color="#FFF"
    >
      <ImageWithSkeleton src={MATERIAL_ATTR_MAP[feature.value]?.img} />
    </St.Container>
  );
};

export default SlabViewerTooltip;
